const registerServiceWorker = (): void => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(function () {
        // console.log('Registration successful, scope is:', registration.scope);
      })
      .catch(function () {
        // console.log('Service worker registration failed, error:', err);
      });
  }
};

export { registerServiceWorker };
